import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import minMax from "dayjs/plugin/minMax";
import utc from "dayjs/plugin/utc";
import { cap_adjusted_values } from "../../utils/CapCurrencyValues";
import { getGroupData, getPoaIndex, getSelectedPeriod } from "../GroupContext";
import {
  calculateNetTaxInterestExpense,
  calculateTaxEBITDA,
} from "./EntityCalculations";

dayjs.extend(isSameOrAfter);
dayjs.extend(minMax);
dayjs.extend(utc);

const getReviewCalc1Values = () => {
  const savedData = getGroupData();
  const selectedPoA = getSelectedPeriod();

  const ukCompanyIDs = selectedPoA?.ukCompanyIDs;
  const new_cap_data = selectedPoA?.adjusted_caps
    ?.map((cap) => {
      const company = savedData?.companies?.find(
        (c) => c?.company_ID === cap?.company_ID,
      );

      // This shouldn't really happen but just a check in case
      if (!company) {
        throw new Error("Failed to find company with id", cap?.company_ID);
      }

      // Return the cap as-is for non-UK companies
      if (!ukCompanyIDs.includes(company?.company_ID)) {
        return null; // Instead of returning cap, return null to exclude this from final results
      }

      let inclusion_factor = cap?.inclusion_factor;
      let adjustment_status =
        inclusion_factor < 1 ? "Automatic Adjustment" : "No Adjustment";
      Object.entries(cap)?.forEach(([key, entry]) => {
        if (cap_adjusted_values?.includes(key)) {
          if (
            cap?.hasOwnProperty(key) &&
            cap[key] &&
            cap[key]?.manual_adjustment === true
          ) {
            adjustment_status = "Manual Adjustment";
          }
        }
      });
      const net_tax_interest_expense = calculateNetTaxInterestExpense(cap);
      const tax_ebitda = calculateTaxEBITDA(cap);

      const calculated_data = {
        adjustment_status,
        net_tax_interest_expense,
        tax_ebitda,
      };

      // Return the adjusted cap with the new data
      return { ...cap, ...calculated_data };
    })
    .filter((cap) => cap !== null); // Filter out the null values (non-UK companies)

  return new_cap_data;
};

export default getReviewCalc1Values;
